import { setYear } from './set-year';
/**
 * @hidden
 */

export var normalizeYear = function normalizeYear(value, year) {
  return setYear(value, year(value.getFullYear()));
};